﻿import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { ILiveDataListenerContext, ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { ISiteObservationsPage } from "./ISiteObservationsPage";
import { ValueBox } from "./ValueBox";

export class Motion implements ISiteObservationsPage {

    public id: string = 'motion';
    public label: string = 'Motion';

    public station: ParameterSchemaStation;
    public warningGroup: WarningGroup;

    public notifyResize() {
    }

    public show(station: ParameterSchemaStation): boolean {

        let sensorCount = 0;

        for (let sensorId in station.Sensors) {
            sensorCount++;

            const sensor = station.Sensors[sensorId];

            for (let paramId in sensor.Parameters) {
                if (paramId.indexOf('Motion') != -1) {
                    return true;
                }
            }
        }
        return false;
    }

    constructor(public mainSite: MainSite, private ctx: ILiveDataListenerContext) {
    }

    public render(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation, warningGroup: WarningGroup): void {
        this.station = station;
        this.warningGroup = warningGroup;

        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');

        var leftPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '48em')
            .css('width', '20em')
            .appendTo(page);

        var centrePanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '48em')
            .css('left', '21em')
            .css('width', '20em')
            .appendTo(page);

        var rightPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '48em')
            .css('left', '42em')
            .css('width', '20em')
            .appendTo(page);

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Roll_Left_deg_Max),
                0, 0, 24, 100, this.ctx)
            );   

        listeners.push(
            new ValueBox(this,
                centrePanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Roll_Right_deg_Max),
                0, 0, 24, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Excursion_Distance_m_Max),
                0, 0, 24, 100, this.ctx)
        );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.PitchBowUp_deg_Max),
                25, 0, 24, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                centrePanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.PitchBowDown_deg_Max),
                25, 0, 24, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Excursion_Bearing_deg),
                25, 0, 24, 100, this.ctx)
        );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Heave_Rate_mps_Max),
                50, 0, 24, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                centrePanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Heave_m_Max),
                50, 0, 24, 100, this.ctx)
            );


        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Heave_Period_s_Mean),
                50, 0, 24, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.MMS),
                75, 0, 24, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                centrePanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.MSI),
                75, 0, 24, 100, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Inclination_deg_Max),
                75, 0, 24, 100, this.ctx)
        );
        

        page.appendTo(container);
    }
}